import React from "react";

import Paper from "@mui/material/Paper";

import { FitWidth, Title } from "components/common";
import Tabs, { Tab } from "components/Tabs";
import EventsLoader from "components/Loader";
import { useHistory } from "react-router-dom";

const CountBox = ({ transactionByCount, transactionByName, atRiskCount }) => (
  <div class="flex_column count_item">
    <div className="half-flex" style={{ height: "30%" }}>
      <text>{transactionByName}</text>
    </div>
    <div className="half-flex flex_column" style={{ height: "60%" }}>
      <text className="count-text">{transactionByCount}</text>
      <text
        className={` badge ${atRiskCount && atRiskCount > 0 ? "" : "  hidden"}`}
      >
        At Risk: {atRiskCount}
      </text>
    </div>
    <div></div>
  </div>
);

const Chart = ({ model, type, title }) => {
  const history = useHistory();

  const handleOnClick = (i) => {
    if (type === "status") {
      if (title === "Transactions") {
        history.push(`transaction?filterBy=Status&id=${i === 6 ? 0 : i}`);
      } else {
        history.push(`pre-transaction?filterBy=Status&id=${i === 6 ? 0 : i}`);
      }
    } else {
      if (title === "Transactions") {
        history.push(`transaction?filterBy=Type&id=${i}`);
      } else {
        history.push(`pre-transaction?filterBy=Type&id=${i}`);
      }
    }
  };
  return (
    <div className="count_container flex_row">
      {model.map((item, i) => (
        <div
          key={item.transactionById}
          onClick={() => handleOnClick(item.transactionById)}
        >
          <CountBox {...item} />
        </div>
      ))}
    </div>
  );
};

const NumberCharts = ({ title, transactionCounts, isLoading }) => {
  if (!transactionCounts) return null;

  const { byStatus, byType } = transactionCounts;

  return (
    <FitWidth>
      <Title>{title}</Title>
      {isLoading ? (
        <>
          <EventsLoader />
        </>
      ) : (
        <>
          <Paper padding={"1em"} elevation={2}>
            <Tabs>
              <Tab
                label={"By Status"}
                component={
                  <Chart model={byStatus} title={title} type="status" />
                }
              />
              <Tab
                label={"By Type"}
                component={<Chart model={byType} title={title} type="type" />}
              />
            </Tabs>
          </Paper>
        </>
      )}
    </FitWidth>
  );
};

export default NumberCharts;
